import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "./i18n";
import { EnquiryProvider } from "./components/EnquiryContext";
import { ConsentProvider } from "./components/CookieBanner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Atelier from "./pages/Atelier";
import Collection from "./pages/Collection";
import DressDetail from "./pages/DressDetail";
import Rental from "./pages/Rental";
import Appointments from "./pages/Appointments";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Admin from "./pages/Admin";

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, [pathname]);
  return null;
}

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="grain min-h-screen flex flex-col">
      {!isAdmin && <Navbar />}
      {!isAdmin && <WhatsAppFloat />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/atelier" element={<Atelier />} />
          <Route path="/collezione" element={<Collection />} />
          <Route path="/collezione/:id" element={<DressDetail />} />
          <Route path="/noleggio" element={<Rental />} />
          <Route path="/appuntamenti" element={<Appointments />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <ErrorBoundary>
          <EnquiryProvider>
            <ConsentProvider>
              <Shell />
            </ConsentProvider>
          </EnquiryProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
